<template>
  <!-- Intentionally blank: this is a handoff page -->
  <div class="min-h-screen w-full bg-white" />
</template>

<script>
export default {
  name: "OktaRedirect",
  mounted() {
    // Force a full page navigation so Laravel can 302 to Okta.
    // Use rAF to allow Vue to paint this "blank" handoff page first.
    requestAnimationFrame(() => {
      const url = new URL(`${window.location.origin}/login/okta`);
      // Preserve any query params (e.g. email/login_hint) for Okta prefill.
      url.search = window.location.search;
      // Use replace (not assign) so this handoff URL does not stay in browser history;
      // otherwise pressing Back after login returns here and re-triggers Okta (AP-5086 #2b).
      window.location.replace(url.toString());
    });
  },
};
</script>

